import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.originalOptions = Array.from(this.selectTarget.options)
  }

  filter(event) {
    const query = event.target.value.toLowerCase().trim()

    if (query.length < 2) {
      this.restoreOptions()
      return
    }

    const filtered = this.originalOptions.filter(opt => {
      if (opt.value === "") return true // Keep blank option
      return opt.text.toLowerCase().includes(query)
    })

    this.selectTarget.innerHTML = ""
    filtered.forEach(opt => {
      this.selectTarget.appendChild(opt.cloneNode(true))
    })
  }

  restoreOptions() {
    this.selectTarget.innerHTML = ""
    this.originalOptions.forEach(opt => {
      this.selectTarget.appendChild(opt.cloneNode(true))
    })
  }
}
